import { render } from "./pc.vue?vue&type=template&id=0bade133"
import script from "./pc.vue?vue&type=script&lang=js"
export * from "./pc.vue?vue&type=script&lang=js"

import "./pc.vue?vue&type=style&index=0&id=0bade133&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-snapshot-search/template4/components/market-report/pc.vue'],['render',render],['__file',"pc.vue"]])

export default __exports__